//Stepper
export const NEXT_STEP = "NEXT_STEP";
export const LAST_STEP = "LAST_STEP";
export const SKIP_STEP = "SKIP_STEP";
export const SKIP_BACK = "SKIP_BACK";
export const NO_STICKY = "NO_STICKY";
export const SET_VALID = "SET_VALID";
export const SET_INVALID = "SET_INVALID";
export const SET_BACK_VALID = "SET_BACK_VALID";
export const SET_BACK_INVALID = "SET_BACK_INVALID";

//////signingInfo\\\\\\
//signature
export const SIGNATURE_COMPLETED = "SIGNATURE_COMPLETED";
export const SIGNATURE_VALIDATED = "SIGNATURE_VALIDATED";
export const SIGNATURE_RECEIVED = "SIGNATURE_RECEIVED";
export const WAIVER_SIGNED = "WAIVER_SIGNED";
export const GUID_SET = "GUID_SET"
//waiverInfo
export const CURRENT_WAIVER_RETRIEVED = "CURRENT_WAIVER_RETRIEVED";
export const WAIVER_LOADING_FAILED = "WAIVER_LOADING_FAILED";
export const WAIVER_REQUESTED = "WAIVER_REQUESTED";
//AboutSigner Page
export const ROLE_SELECTED = "ROLE_SELECTED";

//Collect Marketing Information
export const MARKETING_INFORMATION_COLLECTED =
  "MARKETING_INFORMATION_COLLECTED";
export const SIGNER_NAME_COLLECTED = "SIGNER_NAME_COLLECTED";
export const PARTICIPANTS_COLLECTED = "PARTICIPANTS_COLLECTED";
//ParticipantForm Tab
export const PARTICIPANT_DATA_COLLECTED = "PARTICIPANT_DATA_COLLECTED";

//Signer Video
export const OPENTOK_REQUESTED = "OPENTOK_REQUESTED";
export const OPENTOK_REQUEST_FAILED = "OPENTOK_REQUEST_FAILED";
export const OPENTOK_REQUEST_SUCCEEDED = "OPENTOK_REQUEST_SUCCEEDED";
export const RECORDING_START_FAILED = "RECORDING_START_FAILED";
export const RECORDING_START_REQUESTED = "RECORDING_START_REQUESTED";
export const RECORDING_START_SUCCEEDED = "RECORDING_START_SUCCEEDED";
export const RECORDING_STOP_FAILED = "RECORDING_STOP_FAILED";
export const RECORDING_STOP_REQUESTED = "RECORDING_STOP_REQUESTED";
export const RECORDING_STOP_SUCCEEDED = "RECORDING_STOP_SUCCEEDED";
export const PERMISSIONS_SET = "PERMISSIONS_SET"

//signedWaiver
export const SIGNED_WAIVER_SUCCEEDED = "SIGNED_WAIVER_SUCCEEDED";
export const SIGNED_WAIVER_FAILED = "SIGNED_WAIVER_FAILED";
export const SIGNED_WAIVER_SUBMIT_STARTED = "SIGNED_WAIVER_SUBMIT_STARTED";
export const VALUES_SUBMITTED = "VALUES_SUBMITTED";
export const LOCATION_RETRIEVED = "LOCATION_RETRIEVED";

//path info
export const PATH_REFERENCE_RETRIEVED = "PATH_REFERENCE_RETRIEVED";
export const PATH_PARTICIPANTS_RETRIEVED = "PATH_PARTICIPANTS_RETRIEVED";
export const PATH = "PATH"
//export const PATH_PARTICIPANT_INFO_RETRIEVED = "PATH_PARTICIPANT_INFO_RETRIEVED"

////LinkedParticipants
export const LINKED_PARTICIPANT_SELECTED = "LINKED_PARTICIPANT_SELECTED";
export const LINKED_PARTICIPANTS_SELECTED = "LINKED_PARTICIPANTS_SELECTED";
export const LINKED_PARTICIPANT = "LINKED_PARTICIPANT";
export const LINKED_PARTICIPANTS = "LINKED_PARTICIPANTS";
export const LINKED_PARTICIPANTS_COLLECTED = "LINKED_PARTICIPANTS_COLLECTED";
export const LINKED_PARTICIPANTS_SIGNEDBY = "LINKED_PARTICIPANTS_SIGNEDBY";
export const LINKED_PARTICIPANTS_ROLE3 = "LINKED_PARTICIPANTS_ROLE3";
export const PARTICIPANTS_BIRTHDAYS_COLLECTED =
  "PARTICIPANTS_BIRTHDAYS_COLLECTED";

export const PARTICIPANT_REMOVED = "PARTICIPANT_REMOVED";
export const PPS_SELECTED = "PPS_SELECTED";
export const UPDATE_PPS = "UPDATE_PPS";
export const UPDATE_PPS_ROLE3 = "UPDATE_PPS_ROLE3";
export const SELECTED = "SELECTED";
export const SELECTED_NAMES = "SELECTED_NAMES";
export const ON_SELECT = "ON_SELECT";

export const PARTICIPANTS_AND_SIGNER_COLLECTED =
  "PARTICIPANTS_AND_SIGNER_COLLECTED";

export const NONE_SELECTED = "NONE_SELECTED";
export const NEXT_SELECTED = "NEXT_SELECTED";
export const NEXT_CONFUSED = "NEXT_CONFUSED";

//new\\
export const SKIPPED_BACKWARDS = "SKIPPED_BACKWARDS";
export const PARTICIPANTS_RESET = "PARTICIPANTS_RESET";
export const PATH_PARTICIPANTS_RESET = "PATH_PARTICIPANTS_RESET";
